<template>
  <div class="w-input">
    <div class="main-sender">
      <slot></slot>
      <button @click="this.$emit('send-content')">
        <i class="fas fa-angle-right fa-2x"></i>
      </button>
    </div>
    <transition name="from-bottom">
      <div class="replying-guide" v-if="reply">
        <button @click="$emit('no-reply')">
          <i class="fas fa-times"></i>
        </button>
        <span>
          {{ reply }}
        </span>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "WInput",
  props: ["reply"],
};
</script>

<style lang="scss">
.w-input {
  z-index: 10;
  direction: ltr;
  position: fixed;
  padding: 0 !important;
  height: 80px;

  .main-sender {
    z-index: 4;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    position: relative;
    background-color: var(--bg2);
    box-shadow: 0 -1px 8px -2px var(--shadow);
    // padding: 20px 0;
  }
  bottom: 0;
  left: 0;
  width: 100%;
  textarea {
    width: 70%;
    height: 50px;
    padding: 10px 20px;
    border-radius: 40px;
    border: none;
    outline: none;
    font-size: 1.08em;
    background-color: var(--tent);
    color: var(--text);
    resize: none;
    // box-shadow: 0px 1px 10px -4px var(--shadow);
  }

  button {
    background-color: var(--tent);
    color: var(--accent);
    padding: 7px 14px;
    border-radius: 50%;
  }

  .replying-guide {
    z-index: 3;
    position: fixed;
    bottom: 78px;
    left: 0;
    padding: 14px 14px;
    width: 100%;
    height: 50px;
    color: white;
    background-color: var(--accent);
    display: flex;
    flex-flow: column wrap;
    justify-content: center;
    align-content: flex-start;

    span {
      margin: 0 4px;
      max-width: 90%;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    button {
      width: 10%;
      width: fit-content;
      i {
        color: white;
      }
    }
  }
}
</style>
